import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const exportComponentAsPDF = async (ref, fileName = "Report.pdf") => {
  if (!ref?.current) {
    console.error("Invalid ref provided!");
    return;
  }

  try {
    const input = ref.current;
    const canvas = await html2canvas(input, { scale: 2 });
    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");
    const imgWidth = 190; // A4 width in mm
    const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

    pdf.addImage(imgData, "PNG", 10, 0, imgWidth, imgHeight);
    pdf.save(fileName);
  } catch (error) {
    console.error("Error exporting PDF:", error);
  }
};

export default exportComponentAsPDF;
